export default __webpack_public_path__ + "static/media/logo.003a41cd.png";